import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ProductPricing } from '@galaxy/billing';
import { AppPrice } from '@galaxy/marketplace-apps';
import { AppEditionsMarketing, ProductCost } from '@galaxy/marketplace-apps/v1';
import { BehaviorSubject } from 'rxjs';
import { MarketingType } from '../product-details-v2.interface';

export interface EditionTabData extends AppEditionsMarketing {
  pricingType: string;
  pricing: ProductCost | ProductPricing;
}

@Component({
  selector: 'store-editions-marketing',
  templateUrl: './editions-marketing.component.html',
  styleUrls: ['./editions-marketing.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditionsMarketingComponent implements AfterViewInit, OnChanges {
  @Input() contactSales: boolean;
  @Input() marketingType: MarketingType;
  @Input() billingPrice: { [sku: string]: ProductPricing };
  @Input() appPrice: AppPrice;
  @Input() currency: string;
  @Input() editionsMarketing: AppEditionsMarketing[];
  @Input() editionOrder: string[];
  @Input() isEditionActionUsed = false;

  @Output() editionActionClick = new EventEmitter();

  priceAreaHeight$$: BehaviorSubject<number> = new BehaviorSubject(null);
  priceCardData: EditionTabData[];

  ngAfterViewInit(): void {
    window.setTimeout(() => this.matchPricingAreaHeight(), 0);
  }

  ngOnChanges(): void {
    if (this.billingPrice && Object.keys(this.billingPrice).length !== 0) {
      this.priceCardData = this.prepareTabData(
        this.billingPrice,
        this.editionsMarketing,
        'billingPrice',
        this.editionOrder,
      );
    } else {
      this.priceCardData = [];
      this.editionsMarketing.forEach((edition) => {
        this.priceCardData.push({
          pricingType: 'billingPrice',
          pricing: undefined,
          ...(edition as any),
        });
      });
    }
  }

  prepareTabData(
    pricing: { [sku: string]: ProductPricing } | ProductCost,
    marketing: AppEditionsMarketing[],
    type: string,
    order: string[],
  ): EditionTabData[] {
    const tabData: EditionTabData[] = [];
    Object.keys(pricing).forEach((key) => {
      const curObj = pricing[key];
      const curObjEditions = curObj.editionCost;
      if (curObjEditions) {
        Object.keys(curObjEditions).forEach((edKey) => {
          const curPricing = curObjEditions[edKey];
          curPricing.commitment = curObj.commitment;
          tabData.push({
            pricingType: type,
            pricing: curPricing,
            ...(marketing?.find((m) => m.billingId === edKey) as any),
          });
        });
      } else {
        tabData.push({
          pricingType: type,
          pricing: pricing[key],
          ...(marketing?.find((m) => m.billingId === key) as any),
        });
      }
    });
    if (!order && !!marketing && marketing.length) {
      order = marketing.map((m) => m.billingId);
    }
    return this.orderTabData(tabData, order);
  }

  orderTabData(data: EditionTabData[], order: string[]): EditionTabData[] {
    data.sort((a, b) => {
      const A = a.billingId,
        B = b.billingId;
      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });
    return data;
  }

  matchPricingAreaHeight(): void {
    const priceContainers = Array.from(document.getElementsByClassName('marketing-price-container'));
    priceContainers.map((t) => {
      if (!this.priceAreaHeight$$.getValue() || this.priceAreaHeight$$.getValue() < t.clientHeight) {
        this.priceAreaHeight$$.next(t.clientHeight);
      }
    });
  }
}
